<template>
  <el-row class="coal-block">
    <el-row>
      <el-col :span="1"><el-row class="zy-icon-carbon" /></el-col>
      <el-col :span="4">
        <el-row class="screen-title">CO₂排放</el-row>
        <el-row class="title-underline"/>
      </el-col>
    </el-row>
    <el-row style="align-items: center;" :style="getDiffStyle(0)">
      <el-col class="left-border-title screen-title">年CO₂排放量</el-col>
    </el-row>
    <el-row style="width: 100%;position: absolute;" :style="getDiffStyle(-2)">
      <common-charts :index="'_coal_gauge'" :options="coalGauge"
                     :style="getDiffStyle(1)" :key="timeStamp"/>
    </el-row>
    <el-row :style="getDiffStyle(-1)">
      <el-col span="1" style="height: 100%;" />
      <el-col span="10" class="corner-box">
        <el-row style="color: #FCB268;height: 60%;" :style="getDiffStyle(-3)">{{ getCoal(coalData.yearCoal) }} {{ getCoal(coalData.yearCoal, true) }}</el-row>
        <el-row style="color: #FCB268;height: 40%;" :style="getDiffStyle(-4)">碳排放</el-row>
      </el-col>
      <el-col span="2" style="height: 100%;" />
      <el-col span="10" class="corner-box-2">
        <el-row style="color: #fff;height: 60%;" :style="getDiffStyle(-3)">{{ getCoal(coalData.coalLimit) }} {{ getCoal(coalData.coalLimit, true) }}</el-row>
        <el-row style="color: #fff;height: 40%;" :style="getDiffStyle(-4)">碳配额</el-row>
      </el-col>
    </el-row>
<!--    <el-row :style="getDiffStyle(9)" style="text-align: center;" :gutter="10">-->
<!--      <el-col :span="6" style="color: #43CCEA;height: 100%;">-->
<!--        <div class="corner-box-1">{{ getCoal(coalData.coal1) }} {{ getCoal(coalData.coal1, true) }}</div>-->
<!--      </el-col>-->
<!--      <el-col :span="6" style="color: #FDB17D;height: 100%;">-->
<!--        <div class="corner-box-2">{{ getCoal(coalData.coal2) }} {{ getCoal(coalData.coal2, true) }}</div>-->
<!--      </el-col>-->
<!--      <el-col :span="6" style="color: #FCD261;height: 100%;">-->
<!--        <div class="corner-box-3">{{ getCoal(coalData.coal3) }} {{ getCoal(coalData.coal3, true) }}</div>-->
<!--      </el-col>-->
<!--      <el-col :span="6" style="color: #EC5C99;height: 100%;">-->
<!--        <div class="corner-box-4">{{ getCoal(coalData.coal4) }} {{ getCoal(coalData.coal4, true) }}</div>-->
<!--      </el-col>-->
<!--    </el-row>-->
<!--    <el-row :style="getDiffStyle(10)" style="text-align: center;">-->
<!--      <el-col :span="6" style="color: #43CCEA;">化石燃料燃烧</el-col>-->
<!--      <el-col :span="6" style="color: #FDB17D;">碳酸盐使用</el-col>-->
<!--      <el-col :span="6" style="color: #FCD261;">净购入电力/热力</el-col>-->
<!--      <el-col :span="6" style="color: #EC5C99;">CO2回收统计</el-col>-->
<!--    </el-row>-->
  </el-row>
</template>

<script>
import buildCoalGaugeConfig from "../../../config/chart/config_coal_gauge";
import CommonCharts from "../../common/chart/CommonCharts";

export default {
  name: "CoalBlock",
  components: {CommonCharts},
  data() {
    return {
      initOptions: {
        renderer: 'canvas'
      },
      timeStamp: 0,
      coalUnit: 'kg',
      energy: ['电', '水', '气', '热'],
      coalGauge: ''
    }
  },
  props: ["isFull", "coalData"],
  watch: {
    coalData: function (newV, oldV) {
      if(oldV !== newV) this.setData();
    }
  },
  created() {
    this.coalGauge = buildCoalGaugeConfig(this.coalData.coalProp)
    this.timestamp = new Date().getTime()
  },
  methods: {
    getDiffStyle(type, i = -1) {
      if(type === -4) return this.isFull ? 'font-size: 25px;' : 'font-size: 20px;'
      if(type === -3) return this.isFull ? 'font-size: 30px;' : 'font-size: 24px;'
      if(type === -2) return this.isFull ? 'height: 460px;top: 60px;' : 'height: 370px;top: 60px;'
      if(type === -1) return this.isFull ? 'margin-top: 260px;height: 86px;' : 'margin-top: 210px;height: 70px;'
      if(type === 0) return this.isFull ? 'margin-top: 18px;' : 'margin-top: 12px;'
      if(type === 1) return this.isFull ? 'height: 100%;' : 'height: 100%;'
      if(type === 2) return this.isFull ? 'margin-top: 8px;' : 'margin-top: 3px;'
      if(type === 3) return this.isFull ? 'margin-top: 24px;' : 'margin-top: 16px;'
      if(type === 4 && i === -1) return this.isFull ? 'height: 100px;padding-left: 17px;' : 'height: 70px;padding-left: 26px;'
      if(type === 4 && i === 0) return this.isFull ? 'height: 100px;width: 100px;border: 3px dashed #43CCEA;' : 'height: 70px;width: 70px;border: 2px dashed #43CCEA;'
      if(type === 4 && i === 1) return this.isFull ? 'height: 100px;width: 100px;border: 3px dashed #FDB17D;' : 'height: 70px;width: 70px;border: 2px dashed #FDB17D;'
      if(type === 4 && i === 2) return this.isFull ? 'height: 100px;width: 100px;border: 3px dashed #FCD261;' : 'height: 70px;width: 70px;border: 2px dashed #FCD261;'
      if(type === 4 && i === 3) return this.isFull ? 'height: 100px;width: 100px;border: 3px dashed #EC5C99;' : 'height: 70px;width: 70px;border: 2px dashed #EC5C99;'
      if(type === 5) return this.isFull ? 'height: 106px;' : 'height: 80px;'
      if(type === 6) return this.isFull ? 'height: 196px;' : 'height: 156px;'
      if(type === 7) return this.isFull ? 'top: 38px;left: 27px;' : 'top: 24px;left: 13px;'
      if(type === 8) return this.isFull ? 'margin-top: 20px;padding-right: 14px;' : 'margin-top: 20px;padding-right: 12px;'
      if(type === 9) return this.isFull ? 'margin-top: 34px;font-size: 22px;padding-right: 18px;height: 44px;' : 'margin-top: 34px;font-size: 20px;padding-right: 16px;height: 40px;'
      if(type === 10) return this.isFull ? 'margin-top: 20px;font-size: 18px;padding-right: 18px;' : 'margin-top: 18px;font-size: 14px;padding-right: 16px;'
    },
    getCoal(sourceData, isUnit = false) {
      if (sourceData === '-') {
        return sourceData
      }
      let resData = parseFloat(sourceData)
      let resUnit = '吨'
      if(resData) {
        if(sourceData >= 10000) {
          resData = (sourceData / 10000).toFixed(2)
          resUnit = '万吨'
        }else{
          resData = sourceData
        }
      }
      if(isUnit) return resUnit
      else return resData
    }
  }
}
</script>

<style scoped>
.coal-block{
  height: 463px;
  padding: 10px 0 0 20px;
  color: #15AEFE;
  background: url("../../../assets/images/digital-screen/coal-bg.png");
  background-size: 100% 100%;
}
.circle-container{
  border-radius: 50%;
  position: absolute;
  overflow: hidden;
}
.zy-icon-carbon {
  width: 24px;
  height: 25px;
  background: url("../../../assets/images/digital-screen/icon-carbon.png") no-repeat;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/DigitalScreen/CoalBlock.vue